import script from "./Webcast.vue?vue&type=script&lang=ts&setup=true"
export * from "./Webcast.vue?vue&type=script&lang=ts&setup=true"

import "./Webcast.vue?vue&type=style&index=0&id=63f1f8c2&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f1f8c2"]])

export default __exports__